import React from "react";
import get from "lodash/get";
import { useTheme } from "themes/useTheme";

interface IProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  horizontal?: boolean;
  style?: React.CSSProperties;
}

const WhiteSpace = (props: IProps) => {
  const { size = "md", horizontal = false, style } = props;
  const { themeVariables } = useTheme();
  return (
    <div
      style={{
        ...(horizontal
          ? { width: get(themeVariables, `spacing_${size}`, 0) }
          : { height: get(themeVariables, `spacing_${size}`, 0) }),
        ...style,
      }}
    />
  );
};

export default WhiteSpace;
